import simple_logo_tazadeal from './simple_logo_tazadeal.png';
import simple_logo_athena from './simple_logo_athena.png';
import enterprise_logo_tazadeal from './enterprise_logo_tazadeal.png';
import enterprise_logo_athena from './enterprise_logo_athena.png';

const buildName = window.REACT_APP_BUILD_NAME !== 'REPLACE_REACT_APP_BUILD_NAME' ? window.REACT_APP_BUILD_NAME : process.env.REACT_APP_BUILD_NAME || 'tazadeal';
const buildType = window.REACT_APP_BUILD_TYPE !== 'REPLACE_REACT_APP_BUILD_TYPE' ? window.REACT_APP_BUILD_TYPE : process.env.REACT_APP_BUILD_TYPE || 'simple';
const type = buildType?.toLocaleLowerCase()?.trim()
const name = buildName?.toLocaleLowerCase()?.trim()

const logos = {
  simple_logo_tazadeal,
  simple_logo_athena,
  enterprise_logo_tazadeal,
  enterprise_logo_athena
};

const LogoType = logos[`${type}_logo_${name}` as keyof typeof logos] 

export default LogoType;
